export const VMWARE_VM = 'VMware.VirtualMachine';
